import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSpinner, FaSearch, FaTag } from 'react-icons/fa';
import { allProductsPromise } from './allProducts'; // Importing all products
import { ClipLoader } from 'react-spinners'; 
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion'; // Adding framer-motion for animations

import grainsimg from "../public/category-img/grainnn_prev_ui.png";
import floor from "../public/category-img/flour.jpeg";
import oil from "../public/category-img/redvegetableoil_prev_ui.png";
import spices from "../public/category-img/spices_prev_ui.png";
import paste from "../public/category-img/paste.png";
import beverages from "../public/category-img/beveragess_prev_ui.png";
import cannedfood from "../public/category-img/canned_prev_ui.png";
import vegetables from "../public/category-img/vegetables.png";
import fruits from "../public/category-img/fruits_prev_ui.png";
import beauty from "../public/category-img/beautyproducts_prev_ui.png";
import seafoods from "../public/category-img/seafoods_prev_ui.png";
import delicacies from "../public/category-img/delicacies_prev_ui.png";
import sponge from "../public/category-img/sponge_prev_ui.png";

const SearchBar = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSearchFocused, setIsSearchFocused] = useState(false); // Tracks input focus
  const wrapperRef = useRef(null);
  const navigate = useNavigate();

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      // Delay closing to give time for navigation
      setTimeout(() => {
        setIsDropdownOpen(false);
        setIsSearchFocused(false);
      }, 200);
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const products = await allProductsPromise;
        setAllProducts(products);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    fetchProducts();
  }, []);

  const handleProductClick = (product) => {
    if (product.type === 'discount') {
      navigate('/discounts');
    } else {
      navigate(`/product/${product.name}`);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setIsLoading(true);

    if (query.length > 0) {
      setTimeout(() => {
        const results = allProducts.filter((product) =>
          product.name.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredProducts(results);
        setIsDropdownOpen(true);
        setIsLoading(false);
      }, 500);
    } else {
      setFilteredProducts([]);
      setIsDropdownOpen(false);
      setIsLoading(false);
    }
  };


  const renderDropdownContent = () => (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      className="dropdown-content absolute top-10 left-0 w-full bg-white border rounded-lg shadow-lg z-50 max-h-[500px] overflow-auto"
    >
      <div className="p-4">
        <h3 className="font-bold text-[25px] text-[#007D44]">Categories</h3>
        <div className="ml-4">
          <h4 className="font-semibold text-md text-[#007D44]">Non-perishable</h4>
          <div className="flex flex-wrap">
            <ul className="grid grid-cols-5 max-sm:grid-cols-2 gap-4 mr-4 mt-5">
              {/* Category items */}
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={grainsimg} alt="grains" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/grain" className="text-[#007D44] underline-animation ml-1">GRAINS</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={floor} alt="floor" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/flour" className="text-[#007D44] underline-animation ml-1">FLOUR</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={oil} alt="oil" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/oil" className="text-[#007D44] underline-animation ml-1">OIL</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={spices} alt="spices" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/spices" className="text-[#007D44] underline-animation ml-1">SPICES</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={paste} alt="paste" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/paste" className="text-[#007D44] underline-animation ml-1">PASTE</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={beauty} alt="beauty" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/beauty" className="text-[#007D44] underline-animation">BEAUTY</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={beverages} alt="beverages" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/beverages" className="text-[#007D44] underline-animation">BEVERAGES</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={cannedfood} alt="cannedfood" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/canned" className="text-[#007D44] underline-animation">CANNED FOOD</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={seafoods} alt="seafoods" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/seafoods" className="text-[#007D44] underline-animation">SEA FOODS</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={vegetables} alt="vegetables" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/vegetables" className="text-[#007D44] underline-animation">VEGETABLES</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={fruits} alt="fruits" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/fruits" className="text-[#007D44] underline-animation">FRUITS</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={sponge} alt="africansponge" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/africansponge" className="text-[#007D44] underline-animation">SPONGES</Link>
              </motion.li>
              <motion.li 
                className="mb-2"
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <img src={delicacies} alt="ethnic" className="w-16 rounded-full h-16 hover:shadow-lg transition-shadow duration-300" />
                <Link to="/category/ethnic" className="text-[#007D44] underline-animation whitespace-nowrap">ETHNIC DELICACIES</Link>
              </motion.li>
             
            </ul>
          </div>
        </div>
        {/* Add more category sections like perishable */}
      </div>
    </motion.div>
  );

  const renderSearchResults = () => {
    if (filteredProducts.length > 0) {
      return (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
          className="dropdown-content absolute top-10 left-0 w-full bg-white border rounded-lg shadow-lg z-50 max-h-[500px] overflow-auto"
        >
          <ul className="p-4">
            {filteredProducts.map((product, index) => (
              <motion.li 
                key={product.id}  
                onClick={() => handleProductClick(product)} 
                className="flex items-center gap-4 mb-2 p-2 rounded-lg hover:bg-gray-50 cursor-pointer relative"
                initial={{ opacity: 0, y: -5 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2, delay: index * 0.05 }}
                whileHover={{ scale: 1.01, backgroundColor: "#f0f9f4" }}
              >
                <div className="relative">
                  <motion.img
                    src={product.img}
                    alt={product.name}
                    className="w-16 h-16 rounded-full object-cover border-2 border-transparent"
                    whileHover={{ 
                      scale: 1.1, 
                      borderColor: "#007D44",
                      transition: { duration: 0.2 }
                    }}
                  />
                  {product.type === 'discount' && (
                    <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full flex items-center gap-1 animate-pulse">
                      <FaTag /> SALE
                    </div>
                  )}
                </div>
                <div className="flex flex-col">
                  <p className="text-[#007D44] font-semibold transition-colors duration-300 hover:text-[#00522D]">
                    {product.name}
                  </p>
                  {product.type === 'discount' && (
                    <span className="text-xs text-red-500 font-semibold">Special Discount!</span>
                  )}
                </div>
                <div className="ml-auto text-right">
                  {product.type === 'discount' ? (
                    <motion.div 
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 0.1 }}
                      className="flex flex-col items-end"
                    >
                      <div className="relative inline-block">
                        <span className="text-gray-500 font-medium line-through">${product.price}</span>
                        <motion.div 
                          className="absolute top-1/2 left-0 w-full h-[2px] bg-red-500 transform -translate-y-1/2 rotate-[-5deg]"
                          initial={{ width: 0 }}
                          animate={{ width: '100%' }}
                          transition={{ duration: 0.3, delay: 0.2 }}
                        />
                      </div>
                
                    </motion.div>
                  ) : (
                    <span className="text-black font-bold">${product.price}</span>
                  )}
                </div>
              </motion.li>
            ))}
          </ul>
        </motion.div>
      );
    } else {
      return (
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          className="dropdown-content absolute top-10 left-0 w-full bg-white border rounded-lg shadow-lg z-50 p-4"
        >
          <p className="text-gray-500">No results found for "{searchQuery}"</p>
        </motion.div>
      );
    }
  };

  return (
    <div ref={wrapperRef} className="relative flex-grow max-sm:mx-0">
      <motion.input
        type="text"
        placeholder="Search fresh ingredients & products..."
        className="w-[700px] max-sm:w-full p-2 rounded-full max-sm:placeholder:text-xs focus:outline-[#007D44] focus:border-[#007D44] pl-10 transition-all duration-300 border-2 border-transparent focus:border-[#007D44]"
        value={searchQuery}
        onChange={handleSearchChange}
        onFocus={() => setIsSearchFocused(true)} // Set focus state
        onBlur={() => setTimeout(() => setIsSearchFocused(false), 600)} // Delay closing
        onClick={() => setIsDropdownOpen(true)}
        whileFocus={{ scale: 1.01 }}
        initial={{ scale: 1 }}
      />
      {isLoading ? (
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          className="absolute left-3 transform top-[20%] -translate-y-1/2 text-[#007D44]"
        >
          <ClipLoader size={25} color="#007D44" />
        </motion.div>
      ) : (
        <motion.div
          whileHover={{ scale: 1.2 }}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
        >
          <FaSearch />
        </motion.div>
      )}
      
      {/* Conditionally render either categories or search results */}
      <AnimatePresence>
        {isSearchFocused && !searchQuery && renderDropdownContent()}
        {isDropdownOpen && searchQuery && renderSearchResults()}
      </AnimatePresence>
    </div>
  );
};

export default SearchBar;